module.exports = __webpack_public_path__ + "static/media/r_dot_15.63dae4fb.png";